import React from 'react';

const IconLogo = () => (
  /*<svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
          fill="currentColor"
        />
        <polygon
          id="Shape"ß
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>*/
  <svg width="78.125" height="77.344" viewBox="0 0 78.125 77.344" xmlns="http://www.w3.org/2000/svg">
    <g id="logo" stroke-linecap="round" fill-rule="evenodd" font-size="9pt" stroke="#ffffff" stroke-width="0.25mm" style={{ stroke: "#ffffff", strokeWidth: "0.25mm", fill: "none" }}>
      <path d="M 78.125 0 L 77.734 39.941 L 66.113 9.18 L 40.723 11.523 L 40.137 36.816 L 48.535 36.23 L 58.594 18.359 L 57.715 64.063 L 47.852 47.07 L 39.941 46.484 L 39.551 68.164 L 61.133 77.344 L 3.125 77.148 A 718.142 718.142 0 0 0 13.477 72.559 A 188.94 188.94 0 0 1 24.023 68.164 L 22.461 13.965 A 174.247 174.247 0 0 1 11.23 10.254 A 569.634 569.634 0 0 0 0 6.25 A 6774.554 6774.554 0 0 0 39.063 3.027 A 2498.597 2498.597 0 0 1 78.125 0 Z" vector-effect="non-scaling-stroke" fill="currentColor" />
    </g>
  </svg>
);

export default IconLogo;
